<template>
  <div class="parent-add-widget">
    <div class="add-widget-container">
      <BaseIcon name="addWidget" />
      <div class="inner-text">
        {{ $t('addWidgetText') }}
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'AddWidgetComponet' };
</script>

<style lang="scss" scoped>
.inner-text {
  font-size: 1.25rem;
  color: $font-primary;
  margin-top: 1.5rem;
}
.add-widget-container {
  width: 100%;
}
.parent-add-widget {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
